import { Card, Grid, Icon, IconButton, Table, TableBody, TableCell, TableHead, TableRow, MenuItem, Select, FormControl, Dialog, DialogTitle, DialogContent, DialogActions, Switch, Autocomplete, TextField, List, ListItem, ListItemButton, ListItemIcon, Checkbox, ListItemText, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useEffect, useState } from "react";
import { get, post, postNoResponse } from "utils/WebService";
import MDSnackbar from "components/MDSnackbar";

export default function RegrasFilaCreateEdit({ recordId, closeCreateEdit }) {
    const [nome, setNome] = useState("");
    const [ativo, setAtivo] = useState(true);
    const [itens, setItens] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [pessoaOptions, setPessoaOptions] = useState([]);
    
    const [successSB, setSuccessSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const [sbMessage, setSbMessage] = useState("");

    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [pessoaModalOpen, setPessoaModalOpen] = useState(false);
    const [currentEditIndex, setCurrentEditIndex] = useState(null);
    const [statusSearch, setStatusSearch] = useState("");
    const [pessoaSearch, setPessoaSearch] = useState("");

    const [clienteModoGeral, setClienteModoGeral] = useState(false);
    const [globalPessoasIds, setGlobalPessoasIds] = useState([]);
    const [globalPessoasInverter, setGlobalPessoasInverter] = useState(false);

    const [casosModalOpen, setCasosModalOpen] = useState(false);
    const [casosList, setCasosList] = useState([]);
    const [loadingCasos, setLoadingCasos] = useState(false);

    const [detailModalOpen, setDetailModalOpen] = useState(false);
    const [devedorDetail, setDevedorDetail] = useState(null);
    const [loadingDetail, setLoadingDetail] = useState(false);

    useEffect(() => {
        get("/status-ficha/list-all").then((res) => {
            setStatusOptions(res.list || res.data || (Array.isArray(res) ? res : []));
        });

        get("/pessoa/list-all").then((res) => {
            setPessoaOptions(res.list || res.data || (Array.isArray(res) ? res : []));
        });

        if (recordId) {
            get(`/regra-fila/by-id/${recordId}`).then((res) => {
                if (res) {
                    setNome(res.nome || "");
                    setAtivo(res.ativo ?? true);
                    const loadedItens = res.itens || [];
                    setItens(loadedItens);

                    if (loadedItens.length > 0) {
                        const firstPessoas = loadedItens[0].pessoasIds || [];
                        const firstInverter = loadedItens[0].pessoasInverter || false;
                        const allSame = loadedItens.every(it => {
                            const currentPessoas = it.pessoasIds || [];
                            if ((it.pessoasInverter || false) !== firstInverter) return false;
                            if (currentPessoas.length !== firstPessoas.length) return false;
                            return currentPessoas.every(id => firstPessoas.includes(id));
                        });

                        if (allSame && firstPessoas.length > 0) {
                            setClienteModoGeral(true);
                            setGlobalPessoasIds(firstPessoas);
                            setGlobalPessoasInverter(firstInverter);
                        } else {
                            setClienteModoGeral(false);
                            setGlobalPessoasIds([]);
                            setGlobalPessoasInverter(false);
                        }
                    } else {
                        setClienteModoGeral(false);
                        setGlobalPessoasIds([]);
                        setGlobalPessoasInverter(false);
                    }
                }
            });
        } else {
            setNome("");
            setAtivo(true);
            setItens([]);
            setClienteModoGeral(false);
            setGlobalPessoasIds([]);
            setGlobalPessoasInverter(false);
        }
    }, [recordId]);

    const handleSave = () => {
        if (!nome) {
            setSbMessage("Informe o nome da regra.");
            setErrorSB(true);
            return;
        }

        const payloadItens = itens.map(item => ({
            ...item,
            statusFichaIds: Array.isArray(item.statusFichaIds) ? item.statusFichaIds : [],
            statusInverter: item.statusInverter || false,
            pessoasIds: Array.isArray(item.pessoasIds) ? item.pessoasIds : [],
            pessoasInverter: item.pessoasInverter || false,
            regraAgendamento: item.regraAgendamento === "" ? null : item.regraAgendamento,
            saldoMin: item.saldoMin === "" ? null : parseFloat(item.saldoMin),
            saldoMax: item.saldoMax === "" ? null : parseFloat(item.saldoMax),
            pesoOrdem: item.pesoOrdem === "" ? null : parseInt(item.pesoOrdem, 10)
        }));

        const payload = {
            id: recordId,
            nome,
            ativo,
            itens: payloadItens
        };

        postNoResponse("/regra-fila/save", payload).then(() => {
            setSbMessage("Regra salva com sucesso!");
            setSuccessSB(true);
            setTimeout(() => {
                closeCreateEdit();
            }, 1000);
        }).catch(() => {
            setSbMessage("Erro ao salvar regra.");
            setErrorSB(true);
        });
    };

    const handleAddItem = () => {
        setItens([...itens, {
            statusFichaIds: [],
            statusInverter: false,
            pessoasIds: clienteModoGeral ? [...globalPessoasIds] : [],
            pessoasInverter: clienteModoGeral ? globalPessoasInverter : false,
            regraAgendamento: null,
            saldoMin: "",
            saldoMax: "",
            pesoOrdem: itens.length + 1
        }]);
    };

    const handlePessoaToggleGlobal = (pId) => {
        const isChecked = globalPessoasIds.includes(pId);
        const newIds = isChecked ? globalPessoasIds.filter(id => id !== pId) : [...globalPessoasIds, pId];
        setGlobalPessoasIds(newIds);
        setItens(prev => prev.map(item => ({ ...item, pessoasIds: newIds })));
    };

    const handleGlobalPessoasInverterChange = (checked) => {
        setGlobalPessoasInverter(checked);
        setItens(prev => prev.map(item => ({ ...item, pessoasInverter: checked })));
    };

    const handleItemChange = (index, field, value) => {
        const newItens = [...itens];
        newItens[index][field] = value;
        setItens(newItens);
    };

    const handleRemoveItem = (index) => {
        const newItens = itens.filter((_, i) => i !== index);
        setItens(newItens);
    };

    const handleOpenCasosModal = (index) => {
        const item = itens[index];
        if (!item) return;
        setCasosModalOpen(true);
        setLoadingCasos(true);
        setCasosList([]);

        const payloadItem = {
            ...item,
            statusFichaIds: Array.isArray(item.statusFichaIds) ? item.statusFichaIds : [],
            statusInverter: item.statusInverter || false,
            pessoasIds: clienteModoGeral ? (globalPessoasIds || []) : (Array.isArray(item.pessoasIds) ? item.pessoasIds : []),
            pessoasInverter: clienteModoGeral ? (globalPessoasInverter || false) : (item.pessoasInverter || false),
            regraAgendamento: item.regraAgendamento === "" ? null : item.regraAgendamento,
            saldoMin: item.saldoMin === "" ? null : parseFloat(item.saldoMin),
            saldoMax: item.saldoMax === "" ? null : parseFloat(item.saldoMax),
        };

        post("/regra-fila/listar-devedores-item", payloadItem).then((res) => {
            const list = Array.isArray(res) ? res : (res?.data || res?.list || []);
            setCasosList(list);
            setLoadingCasos(false);
        }).catch(() => {
            setLoadingCasos(false);
        });
    };

    const handleOpenDetailModal = (devId) => {
        if (!devId) return;
        setDetailModalOpen(true);
        setLoadingDetail(true);
        setDevedorDetail(null);
        get(`/devedor/by-id/${devId}`).then((res) => {
            setDevedorDetail(res || null);
            setLoadingDetail(false);
        }).catch(() => {
            setLoadingDetail(false);
        });
    };

    const [loadingRecalcular, setLoadingRecalcular] = useState(false);

    const handleRecalcularContadores = () => {
        setLoadingRecalcular(true);
        const dto = {
            id: recordId || null,
            nome,
            ativo,
            itens: itens.map(item => ({
                ...item,
                pessoasIds: clienteModoGeral ? (globalPessoasIds || []) : (Array.isArray(item.pessoasIds) ? item.pessoasIds : []),
                pessoasInverter: clienteModoGeral ? (globalPessoasInverter || false) : (item.pessoasInverter || false),
                regraAgendamento: item.regraAgendamento === "" ? null : item.regraAgendamento,
                saldoMin: item.saldoMin === "" ? null : parseFloat(item.saldoMin),
                saldoMax: item.saldoMax === "" ? null : parseFloat(item.saldoMax),
            }))
        };

        post("/regra-fila/recalcular-contadores", dto).then((res) => {
            const updatedItens = Array.isArray(res) ? res : (res?.data || res?.list || []);
            if (updatedItens.length > 0) {
                setItens(prevItens => prevItens.map((item, idx) => {
                    const match = updatedItens[idx];
                    return {
                        ...item,
                        totalCasos: match && match.totalCasos != null ? match.totalCasos : 0
                    };
                }));
            }
            setSbMessage("Contadores recalculados com sucesso!");
            setSuccessSB(true);
            setLoadingRecalcular(false);
        }).catch(() => {
            setSbMessage("Erro ao recalcular contadores.");
            setErrorSB(true);
            setLoadingRecalcular(false);
        });
    };

    const openStatusModal = (index) => {
        setCurrentEditIndex(index);
        setStatusSearch("");
        setStatusModalOpen(true);
    };

    const closeStatusModal = () => {
        setStatusModalOpen(false);
        if (!pessoaModalOpen) setCurrentEditIndex(null);
    };

    const openPessoaModal = (index) => {
        setCurrentEditIndex(index);
        setPessoaSearch("");
        setPessoaModalOpen(true);
    };

    const closePessoaModal = () => {
        setPessoaModalOpen(false);
        if (!statusModalOpen) setCurrentEditIndex(null);
    };

    const getStatusLabel = (ids) => {
        if (!ids || ids.length === 0) return "Selecionar Status";
        const names = ids.map(id => {
            const st = statusOptions.find(opt => opt.id === id);
            return st ? (st.ccNome || st.id) : id;
        });
        return names.join(', ');
    };

    const getPessoasLabel = (ids) => {
        if (!ids || ids.length === 0) return "Selecionar Cliente";
        const names = ids.map(id => {
            const p = pessoaOptions.find(opt => opt.id === id);
            return p ? (p.nomeComum || p.nomeCompleto || p.id) : id;
        });
        return names.join(', ');
    };

    return (
        <Card id="regra-fila-form">
            <MDBox display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1 }}>
                    <MDTypography variant="h5"><Icon>arrow_back</Icon></MDTypography>
                </IconButton>
                <MDTypography variant="h6">{recordId ? "Editar Regra" : "Nova Regra"}</MDTypography>
            </MDBox>

            <MDBox component="section" px={3} pb={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={8}>
                        <MDInput 
                            fullWidth 
                            name="nome" 
                            label="Nome da Regra" 
                            variant="standard" 
                            value={nome} 
                            onChange={(e) => setNome(e.target.value)} 
                            required 
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} display="flex" alignItems="center" pt={4} pl={2}>
                        <MDTypography variant="button" fontWeight="regular" color="text">Inativo</MDTypography>
                        <Switch checked={ativo} onChange={(e) => setAtivo(e.target.checked)} />
                        <MDTypography variant="button" fontWeight="regular" color="text">Ativo</MDTypography>
                    </Grid>
                </Grid>

                {/* Seção de Seleção de Modo do Cliente */}
                <MDBox mt={3} p={2} sx={{ border: "1px solid #e0e0e0", borderRadius: "8px", backgroundColor: "#fafafa" }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={clienteModoGeral ? 5 : 12}>
                            <MDBox display="flex" alignItems="center">
                                <Switch 
                                    checked={clienteModoGeral} 
                                    onChange={(e) => {
                                        const isGeral = e.target.checked;
                                        setClienteModoGeral(isGeral);
                                        if (isGeral) {
                                            const firstPessoas = itens[0]?.pessoasIds || globalPessoasIds || [];
                                            const firstInverter = itens[0]?.pessoasInverter || globalPessoasInverter || false;
                                            setGlobalPessoasIds(firstPessoas);
                                            setGlobalPessoasInverter(firstInverter);
                                            setItens(prev => prev.map(item => ({
                                                ...item,
                                                pessoasIds: [...firstPessoas],
                                                pessoasInverter: firstInverter
                                            })));
                                        }
                                    }} 
                                />
                                <MDBox ml={1}>
                                    <MDTypography variant="button" fontWeight="bold" color="text">
                                        Aplicar Cliente Geral para Todas as Regras
                                    </MDTypography>
                                    <MDTypography variant="caption" color="text" display="block">
                                        {clienteModoGeral 
                                            ? "Um único cliente selecionado no topo é aplicado a todas as regras abaixo" 
                                            : "Modo atual: cada regra possui seu próprio cliente configurado individualmente"}
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                        </Grid>

                        {clienteModoGeral && (
                            <Grid item xs={12} md={7} display="flex" alignItems="center" gap={2}>
                                <MDBox flexGrow={1}>
                                    <MDTypography variant="caption" fontWeight="bold" color="text" display="block" mb={0.5}>
                                        Cliente(s) Geral:
                                    </MDTypography>
                                    <MDButton 
                                        variant="outlined" 
                                        color="info" 
                                        size="small" 
                                        onClick={() => openPessoaModal('global')}
                                        fullWidth
                                        sx={{ textTransform: 'none', whiteSpace: 'normal', minHeight: 'auto', py: 1 }}
                                    >
                                        {getPessoasLabel(globalPessoasIds)}
                                    </MDButton>
                                </MDBox>

                                <MDBox display="flex" alignItems="center" pt={2.5}>
                                    <Switch 
                                        checked={globalPessoasInverter} 
                                        onChange={(e) => handleGlobalPessoasInverterChange(e.target.checked)} 
                                    />
                                    <MDTypography variant="caption" color="text" sx={{ ml: 1, lineHeight: 1.2 }}>
                                        Inverter Regra<br/>(NÃO é este)
                                    </MDTypography>
                                </MDBox>
                            </Grid>
                        )}
                    </Grid>
                </MDBox>

                <MDBox mt={4} mb={2} display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="medium">Regras</MDTypography>
                    <MDBox display="flex" gap={1}>
                        <MDButton 
                            variant="gradient" 
                            color="info" 
                            onClick={handleRecalcularContadores}
                            disabled={loadingRecalcular || itens.length === 0}
                            size="small"
                        >
                            {loadingRecalcular ? (
                                <CircularProgress size={16} color="white" />
                            ) : (
                                <>
                                    <Icon sx={{ mr: 0.5 }}>calculate</Icon> Recalcular Contadores
                                </>
                            )}
                        </MDButton>
                        <MDButton variant="outlined" color="info" onClick={handleAddItem} size="small">
                            <Icon>add</Icon>&nbsp; Adicionar Regra
                        </MDButton>
                    </MDBox>
                </MDBox>

                <Table>
                    <TableHead sx={{ display: "table-header-group" }}>
                        <TableRow>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Status da Ficha</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Cliente(s)</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Agendamento</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Saldo Min (R$)</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Saldo Max (R$)</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Prioridade</MDTypography></TableCell>
                            <TableCell align="center"><MDTypography variant="caption" fontWeight="bold" color="text">Casos</MDTypography></TableCell>
                            <TableCell align="center"><MDTypography variant="caption" fontWeight="bold" color="text">Ação</MDTypography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {itens.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={8} align="center">
                                    <MDTypography variant="caption" color="text">Nenhuma regra adicionada.</MDTypography>
                                </TableCell>
                            </TableRow>
                        )}
                        {itens.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell sx={{ minWidth: 200, whiteSpace: 'normal', verticalAlign: 'top', pt: 1.5 }}>
                                    <MDBox display="flex" flexDirection="column" gap={1}>
                                        <MDButton 
                                            variant="outlined" 
                                            color="info" 
                                            size="small" 
                                            onClick={() => openStatusModal(index)}
                                            fullWidth
                                            sx={{ textTransform: 'none', whiteSpace: 'normal', minHeight: 'auto', py: 1 }}
                                        >
                                            {getStatusLabel(item.statusFichaIds)}
                                        </MDButton>
                                        <MDBox display="flex" alignItems="center">
                                            <Switch 
                                                checked={item.statusInverter || false} 
                                                onChange={(e) => handleItemChange(index, "statusInverter", e.target.checked)} 
                                            />
                                            <MDTypography variant="caption" color="text" sx={{ ml: 1, lineHeight: 1.2 }}>Inverter Regra<br/>(NÃO está nestes)</MDTypography>
                                        </MDBox>
                                    </MDBox>
                                </TableCell>
                                <TableCell sx={{ minWidth: 200, whiteSpace: 'normal', verticalAlign: 'top', pt: 1.5 }}>
                                    {clienteModoGeral ? (
                                        <MDBox display="flex" flexDirection="column" gap={0.5} opacity={0.85}>
                                            <MDButton 
                                                variant="outlined" 
                                                color="secondary" 
                                                size="small" 
                                                disabled
                                                fullWidth
                                                sx={{ textTransform: 'none', whiteSpace: 'normal', minHeight: 'auto', py: 1 }}
                                            >
                                                {getPessoasLabel(globalPessoasIds)}
                                            </MDButton>
                                            <MDTypography variant="caption" color="text" sx={{ fontStyle: 'italic', fontSize: '0.75rem' }}>
                                                (Definido no Cliente Geral)
                                            </MDTypography>
                                        </MDBox>
                                    ) : (
                                        <MDBox display="flex" flexDirection="column" gap={1}>
                                            <MDButton 
                                                variant="outlined" 
                                                color="info" 
                                                size="small" 
                                                onClick={() => openPessoaModal(index)}
                                                fullWidth
                                                sx={{ textTransform: 'none', whiteSpace: 'normal', minHeight: 'auto', py: 1 }}
                                            >
                                                {getPessoasLabel(item.pessoasIds)}
                                            </MDButton>
                                            <MDBox display="flex" alignItems="center">
                                                <Switch 
                                                    checked={item.pessoasInverter || false} 
                                                    onChange={(e) => handleItemChange(index, "pessoasInverter", e.target.checked)} 
                                                />
                                                <MDTypography variant="caption" color="text" sx={{ ml: 1, lineHeight: 1.2 }}>Inverter Regra<br/>(NÃO é este)</MDTypography>
                                            </MDBox>
                                        </MDBox>
                                    )}
                                </TableCell>
                                <TableCell sx={{ verticalAlign: 'top', pt: 1.8 }}>
                                    <FormControl fullWidth variant="standard" sx={{ mt: 1.2 }}>
                                        <Select
                                            value={item.regraAgendamento || ""}
                                            onChange={(e) => handleItemChange(index, "regraAgendamento", e.target.value)}
                                            displayEmpty
                                            sx={{ py: 0.5 }}
                                        >
                                            <MenuItem value=""><MDTypography variant="button" fontWeight="regular">Ignorar</MDTypography></MenuItem>
                                            <MenuItem value={1}><MDTypography variant="button" fontWeight="regular">Atrasado/Hoje ({"<="})</MDTypography></MenuItem>
                                            <MenuItem value={2}><MDTypography variant="button" fontWeight="regular">Futuro ({">"})</MDTypography></MenuItem>
                                            <MenuItem value={3}><MDTypography variant="button" fontWeight="regular">Sem agendamento</MDTypography></MenuItem>
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                <TableCell sx={{ verticalAlign: 'top', pt: 1.8 }}>
                                    <MDInput
                                        variant="standard"
                                        type="number"
                                        value={item.saldoMin || ""}
                                        onChange={(e) => handleItemChange(index, "saldoMin", e.target.value)}
                                        fullWidth
                                    />
                                </TableCell>
                                <TableCell sx={{ verticalAlign: 'top', pt: 1.8 }}>
                                    <MDInput
                                        variant="standard"
                                        type="number"
                                        value={item.saldoMax || ""}
                                        onChange={(e) => handleItemChange(index, "saldoMax", e.target.value)}
                                        fullWidth
                                    />
                                </TableCell>
                                <TableCell sx={{ verticalAlign: 'top', pt: 1.8 }}>
                                    <MDInput
                                        variant="standard"
                                        type="number"
                                        value={item.pesoOrdem || ""}
                                        onChange={(e) => handleItemChange(index, "pesoOrdem", e.target.value)}
                                        fullWidth
                                    />
                                </TableCell>
                                <TableCell align="center" sx={{ verticalAlign: 'top', pt: 2.2 }}>
                                    <MDBox 
                                        px={1.5} 
                                        py={0.5} 
                                        onClick={() => handleOpenCasosModal(index)}
                                        sx={{ 
                                            backgroundColor: '#e3f2fd', 
                                            borderRadius: '12px', 
                                            display: 'inline-block',
                                            minWidth: '45px',
                                            cursor: 'pointer',
                                            transition: 'transform 0.15s, background-color 0.15s',
                                            '&:hover': {
                                                backgroundColor: '#bbdefb',
                                                transform: 'scale(1.08)'
                                            }
                                        }}
                                    >
                                        <MDTypography variant="caption" fontWeight="bold" color="info">
                                            {item.totalCasos != null ? item.totalCasos : 0}
                                        </MDTypography>
                                    </MDBox>
                                </TableCell>
                                <TableCell align="center" sx={{ verticalAlign: 'top', pt: 1.5 }}>
                                    <IconButton color="error" onClick={() => handleRemoveItem(index)}>
                                        <Icon>delete</Icon>
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <MDBox display="flex" justifyContent="flex-end" mt={4}>
                    <MDButton variant="outlined" color="secondary" onClick={closeCreateEdit} sx={{ mr: 2 }}>
                        Cancelar
                    </MDButton>
                    <MDButton variant="contained" color="info" onClick={handleSave}>
                        Salvar
                    </MDButton>
                </MDBox>
            </MDBox>

            <MDSnackbar
                color={successSB ? "success" : "error"}
                icon={successSB ? "check" : "warning"}
                title={successSB ? "Sucesso" : "Erro"}
                content={sbMessage}
                dateTime=""
                open={successSB || errorSB}
                onClose={() => { setSuccessSB(false); setErrorSB(false); }}
                close={() => { setSuccessSB(false); setErrorSB(false); }}
                bgWhite
            />

            <Dialog open={statusModalOpen} onClose={closeStatusModal} fullWidth maxWidth="sm">
                <DialogTitle>Selecionar Status da Ficha</DialogTitle>
                <DialogContent sx={{ minHeight: '300px', pt: 2 }}>
                    {currentEditIndex !== null && (
                        <MDBox>
                            <TextField 
                                variant="outlined" 
                                placeholder="Buscar status..." 
                                fullWidth
                                value={statusSearch}
                                onChange={(e) => setStatusSearch(e.target.value)}
                                sx={{ mb: 2 }}
                            />
                            <List sx={{ maxHeight: 300, overflow: 'auto', border: '1px solid #eee', borderRadius: '4px' }}>
                                {statusOptions.filter(st => {
                                    const nome = st.ccNome || String(st.id) || "";
                                    return nome.toLowerCase().includes(statusSearch.toLowerCase());
                                }).map(st => {
                                    const currentIds = itens[currentEditIndex]?.statusFichaIds || [];
                                    const isChecked = currentIds.includes(st.id);
                                    return (
                                        <ListItem key={st.id} disablePadding>
                                            <ListItemButton onClick={() => {
                                                const newIds = isChecked ? currentIds.filter(id => id !== st.id) : [...currentIds, st.id];
                                                handleItemChange(currentEditIndex, "statusFichaIds", newIds);
                                            }}>
                                                <ListItemIcon>
                                                    <Checkbox edge="start" checked={isChecked} tabIndex={-1} disableRipple />
                                                </ListItemIcon>
                                                <ListItemText primary={st.ccNome || st.id} />
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </MDBox>
                    )}
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={closeStatusModal} color="info">Concluído</MDButton>
                </DialogActions>
            </Dialog>

            <Dialog open={pessoaModalOpen} onClose={closePessoaModal} fullWidth maxWidth="sm">
                <DialogTitle>Selecionar Cliente(s)</DialogTitle>
                <DialogContent sx={{ minHeight: '300px', pt: 2 }}>
                    {currentEditIndex !== null && (
                        <MDBox>
                            <TextField 
                                variant="outlined" 
                                placeholder="Buscar cliente..." 
                                fullWidth
                                value={pessoaSearch}
                                onChange={(e) => setPessoaSearch(e.target.value)}
                                sx={{ mb: 2 }}
                            />
                            <List sx={{ maxHeight: 300, overflow: 'auto', border: '1px solid #eee', borderRadius: '4px' }}>
                                {pessoaOptions.filter(p => {
                                    const nome = p.nomeComum || p.nomeCompleto || String(p.id) || "";
                                    return nome.toLowerCase().includes(pessoaSearch.toLowerCase());
                                }).map(p => {
                                    const currentIds = currentEditIndex === 'global' 
                                        ? globalPessoasIds 
                                        : (itens[currentEditIndex]?.pessoasIds || []);
                                    const isChecked = currentIds.includes(p.id);
                                    return (
                                        <ListItem key={p.id} disablePadding>
                                            <ListItemButton onClick={() => {
                                                if (currentEditIndex === 'global') {
                                                    handlePessoaToggleGlobal(p.id);
                                                } else {
                                                    const newIds = isChecked ? currentIds.filter(id => id !== p.id) : [...currentIds, p.id];
                                                    handleItemChange(currentEditIndex, "pessoasIds", newIds);
                                                }
                                            }}>
                                                <ListItemIcon>
                                                    <Checkbox edge="start" checked={isChecked} tabIndex={-1} disableRipple />
                                                </ListItemIcon>
                                                <ListItemText primary={p.nomeComum || p.nomeCompleto || p.id} />
                                            </ListItemButton>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        </MDBox>
                    )}
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={closePessoaModal} color="info">Concluído</MDButton>
                </DialogActions>
            </Dialog>

            <Dialog 
                open={casosModalOpen} 
                onClose={() => setCasosModalOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6">
                        Casos Encontrados ({casosList.length})
                    </MDTypography>
                    <IconButton onClick={() => setCasosModalOpen(false)} size="small">
                        <Icon>close</Icon>
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {loadingCasos ? (
                        <MDBox display="flex" justifyContent="center" py={4}>
                            <CircularProgress color="info" />
                        </MDBox>
                    ) : casosList.length === 0 ? (
                        <MDBox py={3} textAlign="center">
                            <MDTypography variant="button" color="text">
                                Nenhum caso/devedor encontrado para esta regra.
                            </MDTypography>
                        </MDBox>
                    ) : (
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">ID</MDTypography></TableCell>
                                    <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Devedor</MDTypography></TableCell>
                                    <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">CPF/CNPJ</MDTypography></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {casosList.map((dev, idx) => (
                                    <TableRow 
                                        key={idx} 
                                        hover
                                        onClick={() => handleOpenDetailModal(dev.id || dev.cvId)}
                                        sx={{ 
                                            cursor: 'pointer',
                                            '&:hover': {
                                                backgroundColor: '#e3f2fd !important'
                                            }
                                        }}
                                    >
                                        <TableCell>
                                            <MDTypography variant="button" fontWeight="bold" color="info">
                                                {dev.cvId || dev.id}
                                            </MDTypography>
                                        </TableCell>
                                        <TableCell>
                                            <MDTypography variant="button">
                                                {dev.nome || "-"}
                                            </MDTypography>
                                        </TableCell>
                                        <TableCell>
                                            <MDTypography variant="caption" color="text">
                                                {dev.cpfCnpj || "-"}
                                            </MDTypography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </DialogContent>
                <DialogActions>
                    <MDButton color="secondary" onClick={() => setCasosModalOpen(false)}>
                        Fechar
                    </MDButton>
                </DialogActions>
            </Dialog>

            {/* Modal de Resumo do Devedor */}
            <Dialog
                open={detailModalOpen}
                onClose={() => setDetailModalOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6">
                        Resumo do Devedor {devedorDetail ? `(#${devedorDetail.unencryptedId || devedorDetail.id || ""})` : ""}
                    </MDTypography>
                    <IconButton onClick={() => setDetailModalOpen(false)} size="small">
                        <Icon>close</Icon>
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {loadingDetail ? (
                        <MDBox display="flex" justifyContent="center" py={4}>
                            <CircularProgress color="info" />
                        </MDBox>
                    ) : !devedorDetail ? (
                        <MDBox py={3} textAlign="center">
                            <MDTypography variant="button" color="text">
                                Não foi possível carregar as informações deste devedor.
                            </MDTypography>
                        </MDBox>
                    ) : (
                        <MDBox>
                            {/* Dados Básicos em Cards */}
                            <Grid container spacing={2} mb={2}>
                                <Grid item xs={12} sm={6}>
                                    <MDBox p={1.5} sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                        <MDTypography variant="caption" color="text" display="block">Nome do Devedor</MDTypography>
                                        <MDTypography variant="button" fontWeight="bold">{devedorDetail.nome || "-"}</MDTypography>
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <MDBox p={1.5} sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                        <MDTypography variant="caption" color="text" display="block">CPF / CNPJ</MDTypography>
                                        <MDTypography variant="button" fontWeight="bold">{devedorDetail.documento || "-"}</MDTypography>
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <MDBox p={1.5} sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                        <MDTypography variant="caption" color="text" display="block">Status da Ficha</MDTypography>
                                        <MDTypography variant="button" fontWeight="bold" color="info">
                                            {devedorDetail.statusFichaNome || (devedorDetail.fichas && devedorDetail.fichas[0]?.statusFichaNome) || "Sem Status"}
                                        </MDTypography>
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <MDBox p={1.5} sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                        <MDTypography variant="caption" color="text" display="block">Agendamento</MDTypography>
                                        <MDTypography variant="button" fontWeight="bold">
                                            {devedorDetail.dataAgendamento ? new Date(devedorDetail.dataAgendamento).toLocaleString('pt-BR') : "Sem agendamento"}
                                        </MDTypography>
                                    </MDBox>
                                </Grid>
                            </Grid>

                            {/* Contratos e Saldos */}
                            <MDTypography variant="button" fontWeight="bold" color="text" display="block" mt={2} mb={1}>
                                Contratos e Saldos
                            </MDTypography>
                            {(!devedorDetail.contratos || devedorDetail.contratos.length === 0) ? (
                                <MDTypography variant="caption" color="text">Nenhum contrato encontrado.</MDTypography>
                            ) : (
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Contrato / Título</MDTypography></TableCell>
                                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Situação</MDTypography></TableCell>
                                            <TableCell align="right"><MDTypography variant="caption" fontWeight="bold" color="text">Saldo (R$)</MDTypography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {devedorDetail.contratos.map((c, idx) => {
                                            const saldoVal = c.saldo != null ? Number(c.saldo) : (c.cvSaldo != null ? Number(c.cvSaldo) : (c.valorOriginal != null ? Number(c.valorOriginal) : 0));
                                            const sit = c.situacao != null ? c.situacao : c.cvSituacao;
                                            return (
                                                <TableRow key={idx}>
                                                    <TableCell><MDTypography variant="button">{c.titulo || c.ccTitulo || c.contratoOriginal || `Contrato #${idx + 1}`}</MDTypography></TableCell>
                                                    <TableCell>
                                                        <MDTypography variant="caption" color={sit === 1 || sit === 2 ? "success" : "text"}>
                                                            {sit === 1 ? "Ativo" : sit === 2 ? "Baixado Parcial" : sit === 4 ? "Devolvido" : "Inativo"}
                                                        </MDTypography>
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <MDTypography variant="button" fontWeight="bold">
                                                            {saldoVal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                        </MDTypography>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                        <TableRow sx={{ backgroundColor: '#f0f4f8' }}>
                                            <TableCell colSpan={2}><MDTypography variant="button" fontWeight="bold">Saldo Total Ativo:</MDTypography></TableCell>
                                            <TableCell align="right">
                                                <MDTypography variant="button" fontWeight="bold" color="success">
                                                    {devedorDetail.contratos
                                                        .filter(c => {
                                                            const sit = c.situacao != null ? c.situacao : c.cvSituacao;
                                                            return sit === 1 || sit === 2 || sit == null;
                                                        })
                                                        .reduce((acc, c) => {
                                                            const val = c.saldo != null ? Number(c.saldo) : (c.cvSaldo != null ? Number(c.cvSaldo) : (c.valorOriginal != null ? Number(c.valorOriginal) : 0));
                                                            return acc + val;
                                                        }, 0)
                                                        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                </MDTypography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            )}
                        </MDBox>
                    )}
                </DialogContent>
                <DialogActions>
                    <MDButton color="secondary" onClick={() => setDetailModalOpen(false)}>
                        Fechar
                    </MDButton>
                </DialogActions>
            </Dialog>
        </Card>
    );
}
